import ManageLiquidityPosition from './ManageLiquidityPosition';
import usePositions from '@/application/read/positions/usePositions';
import useAddress from '@/application/read/web3/useAddress';
import useVaults from '@/application/read/vaults/useVaults';
import Icon, { Icons } from '../../elements/Icon';
import getWeakestStatus from '@/presentation/utils/getWeakestStatus';
import useLiquidityPool from '@/application/read/pools/useLiquidityPool';
import { useModalContext } from '@/presentation/context/modal';
import { Address } from 'nftx.js';

export interface ManageLiquidityPositionContainerProps {
  vaultId: string;
  positionId: Address;
}

export const ManageLiquidityPositionContainer = ({
  vaultId,
  positionId,
}: ManageLiquidityPositionContainerProps) => {
  const {
    showClaimRewardsModal,
    showWithdrawLiquidityModal,
    showIncreaseLiquidityModal,
  } = useModalContext();
  const userAddress = useAddress();
  const { data: vaults, status: vaultsStatus } = useVaults();
  const { data, status: positionStatus } = usePositions({
    userAddress,
    vaultId: vaultId,
  });
  const vault = vaults?.find((v) => v.vaultId === vaultId);

  const liquidityPosition = data?.[1].find((p) => p.id === positionId);

  const { data: pool, status: poolStatus } = useLiquidityPool(
    liquidityPosition?.poolId as `0x${string}`
  );

  const status = getWeakestStatus(vaultsStatus, positionStatus, poolStatus);

  const handleClaim = () => {
    showClaimRewardsModal({ vaultId, viewMode: 'liquidity' });
  };
  const handleWithdraw = () => {
    showWithdrawLiquidityModal({ positionId });
  };
  const handleIncrease = () => {
    if (!userAddress) {
      return;
    }
    showIncreaseLiquidityModal({ positionId, userAddress });
  };

  if (status === 'loading') {
    return (
      <div className="p-10 flex justify-center items-center">
        <Icon
          name={Icons.SPINNER_GAP}
          className="animate animate-spin"
          size={32}
        />
      </div>
    );
  }

  if (!liquidityPosition || !vault || !pool) {
    return (
      <div className="p-10 flex justify-center items-center">
        {'No position found :('}
      </div>
    );
  }
  return (
    <ManageLiquidityPosition
      position={liquidityPosition}
      pool={pool}
      vaultId={vaultId}
      symbol={vault.token.symbol}
      onWithdraw={handleWithdraw}
      onClaim={handleClaim}
      onIncrease={handleIncrease}
      tokenAddress={vault.token.id}
    />
  );
};

export default ManageLiquidityPositionContainer;
